import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {ApiGridSearch} from '@assets/js/api/commonApi.js';

const CompGridWeightClass = forwardRef((props, ref) => {
    // Forward ref to allow parent components to call event functions.
    // This is useful for controlling the modal from outside this component.
    useImperativeHandle(ref, () => ({
        onGridSearch: (p_params) => {
            onGridSearch(p_params);
        },
    }));

    /**********************
     * Define Grid vaiable 
    ***********************/
    // State for grid pagination and loading
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });

    // Define columns for DataGrid
    const columns = [
        { field: 'rowNum', headerName: 'No.', width: 65, headerAlign: 'center', align: 'center' },
        { field: 'wetclsGrpCd', headerName: '체급그룹코드', width: 140, headerAlign: 'center', align: 'center' },
        { field: 'wetclsGrpNm', headerName: '체급그룹명', width: 140, headerAlign: 'center', align: 'center',
            renderCell: (params) => (
                <span style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleRowClick(params)}>
                    {params.value}
                </span>
            )
        },
        { field: 'wetclsCd', headerName: '체급코드', width: 120, headerAlign: 'center', align: 'center' },
        { 
            field: 'wetclsNm', 
            headerName: '체급명', 
            width: 200, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => (
                <span style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleRowClick(params)}>
                    {params.value}
                </span>
            )
        },
        { field: 'sortNo', headerName: '순서', width: 80, headerAlign: 'center', align: 'center' },
        { field: 'useYn', headerName: '사용여부', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'crdtDate', headerName: '생성일자', width: 150, headerAlign: 'center', align: 'center' },
    ];

    /*********************
     * Define Grid events
    ***********************/
    const onGridSearch = (p_params) => {
        let params = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            offset: paginationModel.page*paginationModel.pageSize,
            ...p_params
        }

        // <-- loading start
        setLoading(true); 
        // Fetch data from the server
        ApiGridSearch('/sys/wetclsmng/search/list', params)
        .then(res => {
            if (res.data.result) {
                const rows = res.data.dataList && res.data.dataList.length > 0 ? res.data.dataList : [];
                const totalCount = res.data.dataList && res.data.dataList.length > 0 ? res.data.dataList[0].totalCount : 0;
                setRows(rows);
                setTotalRowCount(totalCount);
            } else {
                // Handle case when no data or API returns error
                setRows([]);
                setTotalRowCount(0);
            }
            setRowSelectionModel({ type: 'include', ids: new Set() });
        })
        .catch(error => {
            console.error('Error fetching weight class list:', error);
            // Set empty data on error
            setRows([]);
            setTotalRowCount(0);
        })
        .finally(() => {
            // <-- loading end
            setLoading(false); 
        });
    }

    // Pass selected row data to parent component
    const handleRowClick = (params) => {
        if (params.field === 'wetclsGrpNm') {
            params.row.isGrp = true;
            props.onChildClick(params.row); 
        } else if (params.field === 'wetclsNm') {
            params.row.isGrp = false;
            props.onChildClick(params.row); 
        }
    };

    /**********************
     * Define useEffect
    ***********************/
    useEffect(() => {
        onGridSearch();
        // eslint-disable-next-line
    }, [paginationModel]);

    return (
        <>
            <div className="grid-container">
                <h4>체급 목록</h4>
            </div>
            <div className="grid-wrapper">
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => `${row.mngCd}-${row.wetclsGrpCd}-${row.wetclsCd}`}
                    loading={loading}
                    pageSizeOptions={[100, 200, 500]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    paginationMode="server"
                    rowCount={totalRowCount}
                    checkboxSelection
                    rowSelectionModel={rowSelectionModel}
                    onRowSelectionModelChange={(newSelection) => {
                        if (props.onSelectionChange) {
                            setRowSelectionModel(newSelection);
                            props.onSelectionChange(newSelection);
                        }
                    }}
                    keepNonExistentRowsSelected
                />
            </div>
        </>
    );
});

export default CompGridWeightClass;